export default () => {
  return {
    userInfos: null,
    notificationsPoolingInterval: null,
    appReady: false
  }
}
